import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language.startsWith("ar");

  const menus = [
    { title: t("general_info"), src: "dashboard", path: "/" },
    { title: t("energy"), src: "energy", path: "/energy" },
    { title: t("water"), src: "water", path: "/water" },
    { title: t("transport"), src: "transport", path: "/transport" },
    { title: t("waste"), src: "waste", path: "/waste" },
    { title: t("hotels"), src: "hotels", path: "/hotels" },
    { title: t("biodiversity"), src: "biodiversity", path: "/biodiversity" },
    { title: t("sustainability"), src: "sustainability", path: "/sustainability" },
    { title: t("settings"), src: "settings", path: "/Settings" },
  ];

  const toggleLanguage = () => {
    i18n.changeLanguage(isRTL ? "en" : "ar");
  };

  return (
    <div className="flex z-50 h-full shrink-0 shadow-lg">
      <div
        className={`${
          open ? "w-64 sm:w-72" : "w-16 sm:w-20"
        } relative h-full bg-black/95 p-2 sm:p-4 pt-8 duration-300 overflow-visible flex flex-col justify-between`}
        dir="ltr"
      >
        <div>
          <img
            src={`${process.env.PUBLIC_URL}/assets/control.png`}
            alt="Toggle sidebar"
            className={`absolute cursor-pointer ${
              isRTL ? "-left-3" : "-right-3"
            } top-9 h-7 w-7 rounded-full border-2 border-dark-purple bg-black shadow-sm z-10 ${
              open ? "" : "rotate-180"
            }`}
            onClick={() => setOpen((current) => !current)}
          />

          <div className="flex min-w-0 flex-col items-center text-center">
            <img
              src={`${process.env.PUBLIC_URL}/assets/sinai.png`}
              alt="Logo"
              className={`h-12 sm:h-16 cursor-pointer shrink-0 duration-500 ${
                open ? "rotate-[360deg]" : ""
              }`}
            />
            {open && (
              <h1 className="mt-3 max-w-full text-white text-sm sm:text-base font-bold leading-tight whitespace-normal break-words">
                {t("general_indicators")}
              </h1>
            )}
          </div>

          <ul className="pt-6 space-y-2">
            {menus.map((menu) => {
              const isActive = location.pathname === menu.path;

              return (
                <li
                  key={menu.path}
                  onClick={() => {
                    navigate(menu.path);
                    if (window.innerWidth < 640) setOpen(false);
                  }}
                  className={`flex cursor-pointer items-center gap-x-4 rounded-md px-3 py-2 hover:bg-gray-700 text-gray-300 text-xs sm:text-sm ${
                    isRTL ? "flex-row-reverse" : "flex-row"
                  } ${isActive ? "bg-gray-700 text-white" : ""}`}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/${menu.src}.svg`}
                    alt=""
                    aria-hidden="true"
                    className="h-6 w-6 shrink-0"
                  />
                  <span
                    className={`min-w-0 flex-1 truncate ${
                      isRTL ? "text-right" : "text-left"
                    } ${open ? "block" : "hidden"}`}
                  >
                    {menu.title}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>

        <button
          type="button"
          onClick={toggleLanguage}
          title={isRTL ? "English" : "العربية"}
          className={`mt-4 flex items-center gap-x-4 rounded-md px-3 py-2 hover:bg-gray-700 text-gray-300 text-xs sm:text-sm ${
            isRTL ? "flex-row-reverse" : "flex-row"
          }`}
        >
          <Globe className="h-6 w-6 shrink-0" />
          <span
            className={`min-w-0 flex-1 truncate ${
              isRTL ? "text-right" : "text-left"
            } ${open ? "block" : "hidden"}`}
          >
            {isRTL ? "English" : "العربية"}
          </span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
